import {
  COPIED_TO_CLIPBOARD,
  GENERATE_DEEPLINK,
  GENERATE_DEEPLINK_SUCCESS,
} from "./deeplinkDialog.actions";

const initial = {
  link: "",
  expires: "",
  copiedToClipboard: false,
};

export const deeplinkReducer = (state = initial, action) => {
  switch (action.type) {
    case GENERATE_DEEPLINK: {
      return { ...initial };
    }
    case GENERATE_DEEPLINK_SUCCESS: {
      const { link, expires } = action.payload;
      return { ...state, link, expires };
    }
    case COPIED_TO_CLIPBOARD: {
      return { ...state, copiedToClipboard: true };
    }
    default:
      return state;
  }
};
